import { PASSWORD_RECOVERY_FOOTER_LINKS } from '../constants/passwordRecoveryContent'

export default function AuthRecoveryFooter() {
  return (
    <footer className="mt-auto flex w-full flex-col items-center justify-between gap-4 bg-surface px-6 py-5 md:flex-row md:px-10 lg:px-12">
      <p className="text-[10px] font-medium uppercase tracking-[0.14em] text-secondary">
        &copy; 2026 Bridge Architectural Systems. Internal Use Only.
      </p>

      <nav className="flex flex-wrap items-center justify-center gap-5 sm:gap-8" aria-label="Legal links">
        {PASSWORD_RECOVERY_FOOTER_LINKS.map((link) => (
          <a
            key={link.label}
            href={link.href}
            className="text-[10px] font-medium uppercase tracking-[0.12em] text-secondary transition-colors hover:text-primary"
          >
            {link.label}
          </a>
        ))}
      </nav>
    </footer>
  )
}

